// extracted by mini-css-extract-plugin
export var phone = "_50-0";